import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
var _this = this;
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
export default {
  i18n: require('../i18n-productDetail'),
  props: {
    value: Boolean,
    // 是否显示弹窗
    data: {
      type: [Object, String],
      default: function _default() {
        return null;
      }
    } // 多语言数据
  },
  data: function data() {
    return {
      visible: this.value,
      form: {
        transportTipArr: null // 同捆说明多语言
      }
    };
  },
  watch: {
    value: function (_value) {
      function value(_x) {
        return _value.apply(this, arguments);
      }
      value.toString = function () {
        return _value.toString();
      };
      return value;
    }(function (val) {
      _this.visible = value;
    }),
    data: function data(val) {
      // data 改变了 赋值transportTipArr
      if (_this.data && _this.form.transportTipArr !== null) {
        for (var key in _this.data) {
          _this.form.transportTipArr[key].content = _this.data[key];
        }
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      // 根据语言id 初始化transportTipArr
      var defaultLang = JSON.parse(localStorage.getItem('defaultLangObj'));
      var langList = JSON.parse(localStorage.getItem('langList'));
      this.form.transportTipArr = [];
      var _iterator = _createForOfIteratorHelper(langList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var lang = _step.value;
          this.form.transportTipArr.push({
            langId: lang.langId,
            title: this.$t('priceStock.bundlingNote') + "(".concat(lang.langName, ")"),
            content: this.data[lang.langId] && this.data[lang.langId],
            required: lang.langId === defaultLang.langId
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    ok: function ok() {
      var _this2 = this;
      this.$refs.dataForm.validate(function (valid) {
        if (valid) {
          _this2.$emit('ok', _this2.form.transportTipArr);
        }
      });
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  }
};